import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CircularDependencyError, InvalidResolveSyncError } from './errors';
import { DEFAULT_INJECTION_CONTEXT, Scope } from './injection-context';
import { Reflector } from './reflection';
import { isClassProvider, isFactoryProvider, isValueProvider } from './types';
import { run } from './utils';
import { runHooks } from './utils/hooks';
export var ProviderWrapper = /*#__PURE__*/function () {
  function ProviderWrapper(_hostModule, provider) {
    _classCallCheck(this, ProviderWrapper);

    this._hostModule = _hostModule;
    this._instances = new Map();

    if (typeof provider === 'function') {
      var _Reflector$getProvide = Reflector.getProviderMetadata(provider),
          scope = _Reflector$getProvide.scope;

      this._provider = {
        useClass: provider,
        scope: scope,
        provide: provider
      };
    } else {
      this._provider = _objectSpread({
        scope: Scope.SINGLETON
      }, provider);
    }
  }

  _createClass(ProviderWrapper, [{
    key: "isTransient",
    get: function get() {
      return this._provider.scope === Scope.TRANSIENT;
    }
  }, {
    key: "isSingleton",
    get: function get() {
      return this._provider.scope !== Scope.TRANSIENT;
    }
  }, {
    key: "dependencies",
    get: function get() {
      if (isClassProvider(this._provider)) {
        return Reflector.getConstructorDependencies(this._provider.useClass);
      } else if (isValueProvider(this._provider)) {
        return [];
      } else {
        var _this$_provider$injec;

        return (_this$_provider$injec = this._provider.inject) !== null && _this$_provider$injec !== void 0 ? _this$_provider$injec : [];
      }
    }
  }, {
    key: "name",
    get: function get() {
      return typeof this._provider.provide === 'function' ? this._provider.provide.name : this._provider.provide.toString();
    }
  }, {
    key: "key",
    get: function get() {
      return this._provider.provide;
    }
  }, {
    key: "isAsync",
    value: function isAsync(context, inquirer) {
      var _this = this;

      if (this._hasInstance(context, inquirer)) {
        return false;
      }

      if (isFactoryProvider(this._provider)) {
        return true;
      }

      return this.dependencies.some(function (dep) {
        return _this._resolveDependency(dep, context).isAsync(context, inquirer);
      });
    }
  }, {
    key: "callOnInit",
    value: function () {
      var _callOnInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var inst, _this$_instances$get$, _this$_instances$get, visited, _iterator, _step, _inst;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isSingleton) {
                  _context.next = 6;
                  break;
                }

                inst = this._getSingleton(DEFAULT_INJECTION_CONTEXT);
                _context.next = 4;
                return runHooks(inst, 'onModuleInit');

              case 4:
                _context.next = 26;
                break;

              case 6:
                visited = [];
                _iterator = _createForOfIteratorHelper((_this$_instances$get$ = (_this$_instances$get = this._instances.get(DEFAULT_INJECTION_CONTEXT)) === null || _this$_instances$get === void 0 ? void 0 : _this$_instances$get.values()) !== null && _this$_instances$get$ !== void 0 ? _this$_instances$get$ : []);
                _context.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context.next = 18;
                  break;
                }

                _inst = _step.value;

                if (visited.includes(_inst)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return runHooks(_inst, 'onModuleInit');

              case 15:
                visited.push(_inst);

              case 16:
                _context.next = 10;
                break;

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](8);

                _iterator.e(_context.t0);

              case 23:
                _context.prev = 23;

                _iterator.f();

                return _context.finish(23);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 20, 23, 26]]);
      }));

      function callOnInit() {
        return _callOnInit.apply(this, arguments);
      }

      return callOnInit;
    }()
  }, {
    key: "callOnDidInit",
    value: function () {
      var _callOnDidInit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var inst, _this$_instances$get$2, _this$_instances$get2, visited, _iterator2, _step2, _inst2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isSingleton) {
                  _context2.next = 6;
                  break;
                }

                inst = this._getSingleton(DEFAULT_INJECTION_CONTEXT);
                _context2.next = 4;
                return runHooks(inst, 'onModuleDidInit');

              case 4:
                _context2.next = 26;
                break;

              case 6:
                visited = [];
                _iterator2 = _createForOfIteratorHelper((_this$_instances$get$2 = (_this$_instances$get2 = this._instances.get(DEFAULT_INJECTION_CONTEXT)) === null || _this$_instances$get2 === void 0 ? void 0 : _this$_instances$get2.values()) !== null && _this$_instances$get$2 !== void 0 ? _this$_instances$get$2 : []);
                _context2.prev = 8;

                _iterator2.s();

              case 10:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 18;
                  break;
                }

                _inst2 = _step2.value;

                if (visited.includes(_inst2)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 15;
                return runHooks(_inst2, 'onModuleDidInit');

              case 15:
                visited.push(_inst2);

              case 16:
                _context2.next = 10;
                break;

              case 18:
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](8);

                _iterator2.e(_context2.t0);

              case 23:
                _context2.prev = 23;

                _iterator2.f();

                return _context2.finish(23);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 20, 23, 26]]);
      }));

      function callOnDidInit() {
        return _callOnDidInit.apply(this, arguments);
      }

      return callOnDidInit;
    }()
  }, {
    key: "createInstance",
    value: function () {
      var _createInstance2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.isSingleton) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 3;
                return this.resolveInstance(DEFAULT_INJECTION_CONTEXT);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createInstance() {
        return _createInstance2.apply(this, arguments);
      }

      return createInstance;
    }()
  }, {
    key: "resolveInstance",
    value: function () {
      var _resolveInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context) {
        var inquirer,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                inquirer = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : this;

                if (!this._hasInstance(context, inquirer)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", this.getInstance(context, inquirer));

              case 3:
                _context4.next = 5;
                return this._createInstance(context, inquirer);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function resolveInstance(_x) {
        return _resolveInstance.apply(this, arguments);
      }

      return resolveInstance;
    }()
  }, {
    key: "resolveInstanceSync",
    value: function resolveInstanceSync(context) {
      var inquirer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

      if (this._hasInstance(context, inquirer)) {
        return this.getInstance(context, inquirer);
      }

      if (this.isAsync(context, inquirer)) {
        throw new InvalidResolveSyncError(this.name);
      }

      return this._createInstanceSync(context, inquirer);
    }
  }, {
    key: "getInstance",
    value: function getInstance(context) {
      var _this$_instances$get3;

      var inquirer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var inst = this.isSingleton ? this._getSingleton(context) : (_this$_instances$get3 = this._instances.get(context)) === null || _this$_instances$get3 === void 0 ? void 0 : _this$_instances$get3.get(inquirer);

      if (inst == null) {
        throw new Error('No instance found.');
      }

      return inst;
    }
  }, {
    key: "_hasInstance",
    value: function _hasInstance(context, inquirer) {
      var _this$_instances$get5;

      if (this.isSingleton) {
        var _this$_instances$get4;

        return ((_this$_instances$get4 = this._instances.get(context)) === null || _this$_instances$get4 === void 0 ? void 0 : _this$_instances$get4.get(this)) != null;
      }

      return ((_this$_instances$get5 = this._instances.get(context)) === null || _this$_instances$get5 === void 0 ? void 0 : _this$_instances$get5.get(inquirer)) != null;
    }
  }, {
    key: "_getSingleton",
    value: function _getSingleton(context) {
      var _this$_instances$get6;

      var inst = (_this$_instances$get6 = this._instances.get(context)) === null || _this$_instances$get6 === void 0 ? void 0 : _this$_instances$get6.get(this);

      if (inst == null) {
        throw new Error('No instance found.');
      }

      return inst;
    }
  }, {
    key: "_setSingleton",
    value: function _setSingleton(context, singleton) {
      var inquirerInstances = this._instances.get(context);

      if (inquirerInstances == null) {
        inquirerInstances = new Map();
      }

      inquirerInstances.set(this, singleton);

      this._instances.set(context, inquirerInstances);
    }
  }, {
    key: "_createInstance",
    value: function () {
      var _createInstance3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context, inquirer) {
        var _this2 = this,
            _this$_hostModule$con;

        var deps, inst, inquirerInstances;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this._hasInstance(context, inquirer)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", this.getInstance(context, inquirer));

              case 2:
                _context6.next = 4;
                return this._resolveDependencies(context, inquirer);

              case 4:
                deps = _context6.sent;
                _context6.next = 7;
                return run( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  var Class, _this2$_provider, inject, fn;

                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!_this2._hasInstance(context, inquirer)) {
                            _context5.next = 2;
                            break;
                          }

                          return _context5.abrupt("return", _this2.getInstance(context, inquirer));

                        case 2:
                          if (!isClassProvider(_this2._provider)) {
                            _context5.next = 7;
                            break;
                          }

                          Class = _this2._provider.useClass;
                          return _context5.abrupt("return", _construct(Class, _toConsumableArray(deps)));

                        case 7:
                          if (!isValueProvider(_this2._provider)) {
                            _context5.next = 11;
                            break;
                          }

                          return _context5.abrupt("return", _this2._provider.useValue);

                        case 11:
                          if (!isFactoryProvider(_this2._provider)) {
                            _context5.next = 16;
                            break;
                          }

                          _this2$_provider = _this2._provider, inject = _this2$_provider.inject, fn = _this2$_provider.useFactory;
                          _context5.next = 15;
                          return fn.apply(void 0, _toConsumableArray(inject !== null && inject !== void 0 ? inject : []));

                        case 15:
                          return _context5.abrupt("return", _context5.sent);

                        case 16:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })));

              case 7:
                inst = _context6.sent;

                if (this.isSingleton) {
                  this._setSingleton(context, inst);
                }

                inquirerInstances = this._instances.get(context);

                if (inquirerInstances == null) {
                  inquirerInstances = new Map();
                }

                inquirerInstances.set(inquirer, inst);

                this._instances.set(context, inquirerInstances);

                if (!((_this$_hostModule$con = this._hostModule.container) !== null && _this$_hostModule$con !== void 0 && _this$_hostModule$con.isInitialized)) {
                  _context6.next = 18;
                  break;
                }

                _context6.next = 16;
                return runHooks(inst, 'onModuleInit');

              case 16:
                _context6.next = 18;
                return runHooks(inst, 'onModuleDidInit');

              case 18:
                return _context6.abrupt("return", inst);

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _createInstance(_x2, _x3) {
        return _createInstance3.apply(this, arguments);
      }

      return _createInstance;
    }()
  }, {
    key: "_createInstanceSync",
    value: function _createInstanceSync(context, inquirer) {
      var _this3 = this,
          _this$_hostModule$con2;

      if (this._hasInstance(context, inquirer)) {
        return this.getInstance(context, inquirer);
      }

      var deps = this._resolveDependenciesSync(context, inquirer);

      var inst = run(function () {
        if (_this3._hasInstance(context, inquirer)) {
          return _this3.getInstance(context, inquirer);
        }

        if (isClassProvider(_this3._provider)) {
          var Class = _this3._provider.useClass;
          return _construct(Class, _toConsumableArray(deps));
        } else if (isValueProvider(_this3._provider)) {
          return _this3._provider.useValue;
        } else if (isFactoryProvider(_this3._provider)) {
          var _this3$_provider = _this3._provider,
              inject = _this3$_provider.inject,
              fn = _this3$_provider.useFactory;

          if (fn instanceof Promise) {
            throw new InvalidResolveSyncError(_this3.name);
          }

          return fn.apply(void 0, _toConsumableArray(inject !== null && inject !== void 0 ? inject : []));
        }
      });

      if (this.isSingleton) {
        this._setSingleton(context, inst);
      }

      var inquirerInstances = this._instances.get(context);

      if (inquirerInstances == null) {
        inquirerInstances = new Map();
      }

      inquirerInstances.set(inquirer, inst);

      this._instances.set(context, inquirerInstances);

      if ((_this$_hostModule$con2 = this._hostModule.container) !== null && _this$_hostModule$con2 !== void 0 && _this$_hostModule$con2.isInitialized) {
        runHooks(inst, 'onModuleInit');
        runHooks(inst, 'onModuleDidInit');
      }

      return inst;
    }
  }, {
    key: "_resolveDependencies",
    value: function () {
      var _resolveDependencies2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(context, inquirer) {
        var optionalDependencies, resolvedDependencies, _i, _arr, dep, depWrapper, depValue;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                optionalDependencies = [];
                resolvedDependencies = [];
                _i = 0, _arr = [].concat(_toConsumableArray(this.dependencies), optionalDependencies);

              case 3:
                if (!(_i < _arr.length)) {
                  _context7.next = 18;
                  break;
                }

                dep = _arr[_i];
                depWrapper = this._resolveDependency(dep, context);
                depValue = void 0;

                if (!depWrapper._hasInstance(context, inquirer)) {
                  _context7.next = 11;
                  break;
                }

                depValue = depWrapper.getInstance(context, inquirer);
                _context7.next = 14;
                break;

              case 11:
                _context7.next = 13;
                return depWrapper.resolveInstance(context, inquirer);

              case 13:
                depValue = _context7.sent;

              case 14:
                resolvedDependencies.push(depValue);

              case 15:
                _i++;
                _context7.next = 3;
                break;

              case 18:
                return _context7.abrupt("return", resolvedDependencies);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _resolveDependencies(_x4, _x5) {
        return _resolveDependencies2.apply(this, arguments);
      }

      return _resolveDependencies;
    }()
  }, {
    key: "_resolveDependenciesSync",
    value: function _resolveDependenciesSync(context, inquirer) {
      var optionalDependencies = [];
      var resolvedDependencies = [];

      for (var _i2 = 0, _arr2 = [].concat(_toConsumableArray(this.dependencies), optionalDependencies); _i2 < _arr2.length; _i2++) {
        var dep = _arr2[_i2];

        var depWrapper = this._resolveDependency(dep, context);

        var depValue = void 0;

        if (depWrapper._hasInstance(context, inquirer)) {
          depValue = depWrapper.getInstance(context, inquirer);
        } else {
          depValue = depWrapper.resolveInstanceSync(context, inquirer);
        }

        resolvedDependencies.push(depValue);
      }

      return resolvedDependencies;
    }
  }, {
    key: "_resolveDependency",
    value: function _resolveDependency(dependency, context) {
      if (dependency == null) {
        throw new CircularDependencyError(this.name);
      }

      return this._hostModule.resolveToken(dependency, context);
    }
  }]);

  return ProviderWrapper;
}();